export const getNeedsFromCategories = (categories) => {
    return categories ? categories.reduce((needs, category) => needs.concat(category.needs), []) : []
}